import { getBuilderElement } from "@/components/PageWrapper";
import ProductCardV2 from "@/components/ProductCard/ProductCardV2";
import { CSSProperties, Fragment } from "react";
import classes from "./ProductList.module.css";
import {
  ProductRowSkeleton,
  ProductRowSkeletonFour,
} from "@/containers/skeleton";

interface Props {
  className?: string;
  style?: CSSProperties;
  loading?: boolean;

  products?: ProductItemV2[];
  widgets?: Widget[];
  maxCol?: number;
  activePage?: number;
  perPage?: number;
  total?: number;
}

const widgetNames: WidgetName[] = ["banners"];

const ProductListWidget = ({
  className,
  style,
  loading = false,

  products = [],
  widgets = [],
  maxCol = 4,
  activePage = 0,
  perPage = 20,
  total = 0,
}: Props) => {
  let productStartIndex = 0;

  const pages = Array.from(
    { length: Math.ceil(perPage / maxCol) + 1 },
    (_, k) => k + 1
  );

  const classNames = [classes.ProductList, className];

  if (loading && products.length === 0)
    return (
      <div className="space-y-4 mb-4">
        {[1, 2, 3, 4].map((item) => {
          return <ProductRowSkeletonFour key={`skeleton-${item}`} />;
        })}
      </div>
    );
// console.log("{products}", {widgets});
  return (
    <div className={classNames.join(" ")} style={style}>
      {products.length > 0 &&
        pages.map((_, pageIndex) => {
          return (
            <Fragment key={`page-${pageIndex}`}>
              {widgets.map((widget, index) => {
                const productsInRow = products.slice(
                  productStartIndex,
                  productStartIndex + maxCol
                );

                if (productsInRow.length === 0) return null;

                if (widget.name !== "product-row") {
                  if (!widgetNames.includes(widget.name)) return null;

                  widget.data = {
                    ...widget.data,
                    settings: {
                      ...widget.data?.settings,
                      containerType: "full",
                    },
                  };

                  return getBuilderElement(widget, index);
                }

                productStartIndex += maxCol;

                return (
                  <div
                    className={
                      maxCol === 4
                        ? classes.productRow
                        : "w-full relative grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 xl:gap-3 mb-2 xl:mb-3"
                    }
                    key={`page-${pageIndex}-widget-${index}`}
                  >
                    {productsInRow.map((product) => {
                      return (
                        <ProductCardV2
                          key={product.slug || product.p_id}
                          productItem={product}
                          type="lg"
                        />
                      );
                    })}
                  </div>
                );
              })}
            </Fragment>
          );
        })}

      {products.length === 0 && !loading && (
        <div className="w-full py-10 flex justify-center">
          <span className="text-gray2/80 font-semibold text-xl animate-pulse">
            No products found
          </span>
        </div>
      )}

      {/* {loading && <div className={classes.loading}></div>} */}
    </div>
  );
};

export default ProductListWidget;
